import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/design'
  },
  {
    path: '/design',
    name: 'designFlowWork',
    component: () => import('@/views/DesignFlowWork')
  },
  {
    path: '/from',
    name: 'designForm',
    component: () => import('@/views/DesignForm')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
